import { makeStyles } from "@material-ui/core/styles";
import {
  grey300,
  lightGrey,
  primary,
  primaryLight,
  secondary,
  white,
} from "../../../../infrastructure/theme/customColors";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "65vw",
  },
  subtitle: {
    color: grey300,
    marginTop: -theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  healthLogo: {
    height: 150,
  },
  configContainer: {
    padding: theme.spacing(2),
    backgroundColor: lightGrey,
  },
  serviceIsSelected: {
    backgroundColor: lightGrey,
  },
  buttonBar: {
    paddingTop: theme.spacing(2),
  },
  chipContainer: {
    padding: theme.spacing(1),
  },
  chip: {
    marginRight: theme.spacing(1),
    backgroundColor: "transparent",
    border: `2px solid ${grey300}`,
  },
  productSwitchContainer: {
    padding: theme.spacing(1),
    cursor: "pointer",
  },
  productIsSelected: {
    backgroundColor: grey300,
  },
  activeChip: {
    borderColor: primary,
    backgroundColor: primaryLight,
  },
  percentageAppliedRow: {
    padding: theme.spacing(1),

    "& fieldset": {
      marginRight: theme.spacing(1),
    },
  },
  loaderContainer: {
    padding: theme.spacing(4),
  },
  linkText: {
    color: secondary,
  },
  rowSpacing: {
    paddingBottom: theme.spacing(4),
  },
  attachmentRow: {
    padding: `${theme.spacing(1)}px 0`,
  },
  scheludedMessage: {
    backgroundColor: secondary,
    color: white,
    textAlign: "center",
    borderRadius: "20px",
    maxWidth: "150px",
    marginTop: "5px",
  },
}));

export default useStyles;
